import { User } from "../context/appContext";

const checkPermissionAdmin = (user: User) =>
  user.role?.label === "Admin" ? true : false;

export default checkPermissionAdmin;
